<template>
    <div>
        <h3>Prompt List &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="user" prop="user">
                        <el-input v-model="form.user"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="ID" prop="id">
                        <el-input v-model="form.id"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Title" prop="title">
                        <el-input v-model="form.title"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Prompt" prop="prompt">
                        <el-input v-model="form.prompt"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Source" prop="source">
                        <el-select v-model="form.source" placeholder="请选择Source">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item of Object.keys(Source)" :key="item" :label="Source[item]" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>
        <h5>
            <span></span>
            <el-button type="primary" size="small" :disabled="multipleData.length === 0" :loading="deleteLoad" @click="handleDelete">Delete</el-button>
        </h5>
        <el-table v-loading="tableLoad" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column prop="_id" label="ID" width="220"></el-table-column>
            <el-table-column prop="score" label="Score"></el-table-column>

            <el-table-column label="en-title" width="200">
                <template slot-scope="scope">
                    {{ scope.row.en.title }}
                </template>
            </el-table-column>
            <el-table-column label="en-prompt" width="250">
                <template slot-scope="scope">
                    {{ scope.row.en.prompt }}
                </template>
            </el-table-column>

            <el-table-column label="zh-title" width="200">
                <template slot-scope="scope">
                    {{ scope.row.zh.title }}
                </template>
            </el-table-column>
            <el-table-column label="zh-prompt" width="250">
                <template slot-scope="scope">
                    {{ scope.row.zh.prompt }}
                </template>
            </el-table-column>

            <el-table-column label="origin-title" width="200">
                <template slot-scope="scope">
                    {{ scope.row.origin.title }}
                </template>
            </el-table-column>
            <el-table-column label="origin-prompt" width="250">
                <template slot-scope="scope">
                    {{ scope.row.origin.prompt }}
                </template>
            </el-table-column>

            <el-table-column label="Source" width="220">
                <template slot-scope="scope">
                    {{ Source[scope.row.source] }}
                </template>
            </el-table-column>
            <el-table-column label="User">
                <template slot-scope="scope">
                    {{ scope.row.author_info.name || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="Detail" width="70" fixed="right" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <detail-modal :dialogVisible="detailFlag" :initData="detailData" @closeDetail="closeDetail" v-if="detailFlag" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import { Source } from '../../utils/typing';
import { mapGetters } from 'vuex';
import DetailModal from './detail/index.vue';
export default {
    name: 'prompt',
    components: {
        DetailModal,
    },
    data() {
        return {
            sum: 0,
            form: {
                id: '',
                title: '',
                prompt: '',
                user: '',
                source: '',
            },
            tableData: [],
            tableLoad: false,
            multipleData: [],
            deleteLoad: false,
            searchValue: '',
            params: {
                size: 10,
                page: 1,
            },
            total: 0,

            //
            detailFlag: false,
            detailData: {},
        };
    },
    computed: {
        ...mapGetters({
            lang: 'getLang',
        }),
        Source() {
            return Source;
        },
        dynamicColumns() {
            const lang = this.lang;
            return [
                { prop: lang + '.title', label: 'Title' },
                { prop: lang + '.prompt', label: 'Prompt' },
            ];
        },
    },
    mounted() {
        this.initData();
    },
    methods: {
        async initData(_params) {
            this.tableLoad = true;
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.promptList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;

            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.tableLoad = false;
            }
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.initData(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.initData(this.form);
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleData = val;
            console.log('multipleData: []', this.multipleData);
        },
        handleDelete() {
            this.deleteLoad = true;
            const ids = this.multipleData.map(item => item._id);
            console.log('ids', ids);
            serverApi
                .promptDelete({ ids })
                .then(res => {
                    console.log(' delete success', res);
                    if (res.data.code === 0) {
                        this.$message({
                            message: 'Delete success',
                            type: 'success',
                        });
                        this.initData();
                    } else {
                        this.$message({
                            message: res.data.msg || res.data.error,
                            type: 'error',
                        });
                    }
                })
                .catch(e => {
                    console.log('delete error', e);
                    this.$message({
                        message: e.data.error || e.data.msg,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.deleteLoad = false;
                });
        },
        handleCurrentChange(val) {
            this.params.page = val;
            this.initData();
        },
        handleView(row) {
            console.log('row---->', row);
            this.detailFlag = true;
            this.detailData = row;
        },
        closeDetail(isUpdate) {
            this.detailFlag = false;
            if (isUpdate) {
                this.initData();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}

h4 {
    margin-bottom: 30px;
}

h5 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.demo-input-suffix {
    display: flex;
    align-items: center;
    margin-right: 20px;
}
</style>
